module.exports = __webpack_public_path__ + "img/code-salesperson.2642331a.png";